import { CSSResultGroup, html, TemplateResult } from 'lit'
import { customElement, state } from 'lit/decorators.js'
import { paymentMethodSelectable } from 'components/ordering/checkout/payment-methods/payment-methods.style.js'
import {
  StartMollieRivertyPaymentPayload
} from 'components/ordering/checkout/payment-methods/payment-backend/start-payment-api.js'
import {
  CSCMolliePaymentMethod,
  PaymentMethodState
} from 'components/ordering/checkout/payment-methods/methods/payment-method.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import type { RivertyMethodId } from 'components/ordering/checkout/payment-methods/methods/method-ids.js'


export interface TrydentMollieRivertyData {
  id: RivertyMethodId,
  description: string,
  image_url: string
}


@customElement('csc-mollie-riverty')
export class CSCMollieRiverty extends CSCMolliePaymentMethod {
  static override styles: CSSResultGroup = [hostStyle, paymentMethodSelectable]

  @state() protected readonly paymentMethodId: RivertyMethodId
  @state() protected readonly customDescription: string | null
  @state() protected state: PaymentMethodState

  @state() private readonly description: string
  @state() private readonly imageUrl: string

  constructor({ id, description, image_url }: TrydentMollieRivertyData, state: PaymentMethodState, customDescription: string | null) {
    super()

    this.paymentMethodId = id
    this.customDescription = customDescription
    this.state = state

    this.description = description
    this.imageUrl = image_url
  }

  protected renderPaymentMethodContent = (): TemplateResult => {
    return html`
      <div class="selectable-content">
        <cse-image
          source="${this.imageUrl}"
          alt="${this.description}"
          width="55"
          height="41"
        >
        </cse-image>
        <cse-text>${this.description}</cse-text>
      </div>
    `
  }

  protected getPayload = async (): Promise<StartMollieRivertyPaymentPayload> => {
    return {
      method: this.paymentMethodId,
    }
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'csc-mollie-riverty': CSCMollieRiverty,
  }
}
